/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const Index = gql`
  mutation PlatformMailer($imapConfiguration: smtpConfigurationInput!) {
    PlatformMailer(imapConfiguration: $imapConfiguration) {
      message,
      status
    }
  }
`

/*
 * EXPORTS
 */
export default Index
